import { useUnauthedExperiment } from "../useExperiment/useUnauthedExperiment";
import { useFlippers } from "../useFlippers/useFlippers";

const QUALITY_STORY_SIGNUP_EXPERIMENT_NAME = "qualityStorySignup";

interface Options {
  /** Emit the exposure event only where the variant UI actually differs, so the population isn't diluted. */
  shouldLog: boolean;
}

const useQualityStorySignupExperiment = ({ shouldLog }: Options) => {
  const [
    isQualityStorySignupEnabled,
    isUhCustomExperienceEnabled,
    isAscensionCustomExperienceEnabled,
  ] = useFlippers(
    "platypus_quality_story_signup",
    "vanguard_uh_custom_experience",
    "vanguard_ascension_custom_experience"
  );

  // dora_storefronts must NOT be checked here — it's fully enabled in production, so it reads true for every visitor and would exclude everyone
  const isEligible =
    isQualityStorySignupEnabled &&
    !isUhCustomExperienceEnabled &&
    !isAscensionCustomExperienceEnabled;

  const group = useUnauthedExperiment({
    experiment: QUALITY_STORY_SIGNUP_EXPERIMENT_NAME,
    groups: ["control", "experiment"],
    shouldLog: isEligible && shouldLog,
    e2eGroup: "control",
  });

  return isEligible && group === "experiment";
};

export { QUALITY_STORY_SIGNUP_EXPERIMENT_NAME, useQualityStorySignupExperiment };
